/**
 * Cart Drawer Behavior Enhancement
 * Ensures cart drawer refreshes properly when items are deleted
 * Shows empty state when cart becomes empty
 */

(function() {
  'use strict';

  let previousCartCount = null;

  /**
   * Close cart drawer
   */
  function closeCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && typeof cartDrawer.close === 'function') {
      cartDrawer.close();
    }
  }

  /**
   * Force refresh cart drawer content
   */
  function refreshCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (!cartDrawer) return;

    const cartItemsComponent = cartDrawer.querySelector('.cart-items-component');
    if (!cartItemsComponent) return;

    const sectionId = cartItemsComponent.getAttribute('data-section-id');

    // Try using theme's section renderer first
    if (window.sectionRenderer) {
      window.sectionRenderer.renderSection(sectionId, { cache: false })
        .catch(error => {
          console.error('Error refreshing cart drawer:', error);
          // Fallback to manual refresh
          manualRefreshCartDrawer(sectionId, cartItemsComponent);
        });
    } else {
      // Manual refresh if sectionRenderer not available
      manualRefreshCartDrawer(sectionId, cartItemsComponent);
    }
  }

  /**
   * Manual refresh fallback
   */
  function manualRefreshCartDrawer(sectionId, cartItemsComponent) {
    fetch(`/?section_id=${sectionId}`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector('.cart-items-component');
        
        if (newContent && cartItemsComponent.parentElement) {
          cartItemsComponent.outerHTML = newContent.outerHTML;
        }
      })
      .catch(error => console.error('Manual refresh failed:', error));
  }

  /**
   * Check if we're on the home page
   */
  function isHomePage() {
    return document.body.classList.contains('home_page') || 
           document.body.classList.contains('template-index') ||
           window.location.pathname === '/';
  }

  /**
   * Handle cart count changes
   */
  function handleCartCountChange(itemCount) {
    // If cart just became empty (was > 0, now is 0)
    if (previousCartCount !== null && previousCartCount > 0 && itemCount === 0) {
      // Refresh the cart drawer to show empty state
      setTimeout(() => {
        refreshCartDrawer();
        
        // Also close drawer on home page after a delay
        if (isHomePage()) {
          setTimeout(() => {
            closeCartDrawer();
          }, 500);
        }
      }, 300);
    }
    
    // Update previous count
    previousCartCount = itemCount;
  }

  /**
   * Listen for cart updates and refresh drawer when cart becomes empty
   */
  function initCartDrawerBehavior() {
    // Initialize previous count from current cart state
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        previousCartCount = cart.item_count;
      })
      .catch(() => {
        // Silently fail - will initialize on next cart interaction
      });

    // Listen for cart update events
    document.addEventListener('theme:cart:update', (event) => {
      const itemCount = event.detail?.data?.item_count;
      if (itemCount !== undefined) {
        handleCartCountChange(itemCount);
      } else {
        // If no item count in event, fetch it
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => handleCartCountChange(cart.item_count))
          .catch(error => console.error('Error fetching cart:', error));
      }
    });

    // Also listen for cart:count-updated custom event (from header-cart-count.js)
    document.addEventListener('cart:count-updated', (event) => {
      const itemCount = event.detail?.itemCount;
      if (itemCount !== undefined) {
        handleCartCountChange(itemCount);
      }
    });

  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawerBehavior);
  } else {
    initCartDrawerBehavior();
  }
})();
